<template>
  <div class="about cursorstyle">
    <div class="contentBox cursorstyle" v-if="ForgetPassword">
      <div @click="close()" class=""
           style="float: right; margin-right: 20px; margin-top: 10px;font-size: 16px; color: #CCCCCC;">
        x
      </div>
      <div class="title1">
        <!--				<img src="../assets/logo.png" >-->
        <div class="">
          请登录您的账户
        </div>
      </div>
      <div class="inputbox cursorstyle">
        <el-input placeholder="请输入您的账号" v-model="formData.username"></el-input>
      </div>
      <div class="inputbox cursorstyle">
        <el-input placeholder="请输入您的密码" v-model="formData.password" show-password></el-input>
      </div>
      <div class="tuxingyanzheng cursorStyle">
        <div>
          <el-input placeholder="请输入图形验证" v-model="formData.captcha"></el-input>
        </div>
        <div class="randombox cursorStyle" @click="ImgsRandomFunction">
          <img :src="imgsrandomurl" alt/>
        </div>
      </div>


      <div class="passwordBox cursorstyle">
        <div>
          <el-checkbox v-model="checked">记住密码</el-checkbox>
        </div>
        <div @click="ForgetPasswordBtn">
          忘记密码？
        </div>
      </div>
      <div class="inputboxBTn cursorstyle" @click="loginbtn()">
        登录
      </div>
      <div class="goRegister cursorstyle" @click="goRegister" v-if="loginType == '1' || loginType == '3'">
        您还没有账户？<span style="color: #5764AD; ">注册</span>
      </div>
    </div>
    <div class="contentBox cursorstyle" v-else>
      <div @click="close()" class=""
           style="float: right; margin-right: 20px; margin-top: 10px;font-size: 16px; color: #CCCCCC;">
        x
      </div>
      <div class="title1">
        <div class="">
          忘记密码
        </div>
      </div>
      <div class="inputbox cursorstyle">
        <el-input placeholder="请输入您的手机号" v-model="ForgetForm.mobile"></el-input>
      </div>
      <div class=" cursorstyle" style="display: flex;width: 86%;margin: 0 auto;">
        <div class="inputbox" style="">
          <el-input placeholder="请输入您验证码" v-model="ForgetForm.verify_code"></el-input>
        </div>
        <div class="verifybtn">
          <el-button type="success" @click="verifyButton">{{yzm}}</el-button>
        </div>
      </div>
      <div class="inputbox cursorstyle">
        <el-input placeholder="请输入您的新密码" v-model="ForgetForm.new_password"></el-input>
      </div>
      <div class="inputbox cursorstyle">
        <el-input placeholder="确认新密码" v-model="ForgetForm.retry_new_password"></el-input>
      </div>
      <div class="inputboxBTn cursorstyle" @click="ForgetFormButton">
        确定
      </div>

    </div>
  </div>
</template>
<script>
import {
  loginInt,
  ImgsRandom,
  configInterface,
  verifyInt
} from '@/api/index.js'
import {ForgetFormInt} from "../api";

export default {
  props: {
    loginType: '',
  },
  data() {
    return {
      yzm:'获取验证码',
      time:60,
      //验证码
      imgsrandomurl: '',
      ForgetPassword: true,
      // 记住密码
      checked: '',
      //登录对象
      formData: {
        username: '',
        password: '',
      },
      //忘记密码对象
      ForgetForm: {}
    }


  },
  mounted() {
    console.log(this.ForgetPassword)
    this.ImgsRandomFunction()
  },
  methods: {
    //倒计时方法
    timer() {
      if (this.time > 0) {
        this.disabled = true;
        this.time--;
        this.yzm = this.time + "秒";
        setTimeout(this.timer, 1000);
      } else {
        this.disabled = false;
        this.time = 0;
        this.yzm = "发送验证码";
      }
    },
    //获取验证码
    async ImgsRandomFunction() {
      // this.imgsrandomurl = await ImgsRandom()
      this.imgsrandomurl = window.URL.createObjectURL(await ImgsRandom())
      console.log(this.imgsrandomurl)
    },
    // 去登录
    async loginbtn() {
      if (this.formData.username.length == 0) {
        this.$message.error('请输入用户名')
        return
      }
      if (this.formData.password.length == 0) {
        this.$message.error('请输入密码')
        return
      }
      // 个人登录为1  党政机关2 企业3
      // loginType 登录机构1  个人3
      let nature = null
      if (this.loginType == 3) {
        nature = 1
      } else if (this.loginType == 2) {
        nature = 3
      } else if (this.loginType == 1) {
        nature = 2
      }
      this.formData.nature = nature
      let res = await loginInt(this.formData)
      if (res.code == '00000') {
        //登录成功获取相关配置数据，压入缓存中
        let config = await configInterface();
        // 将配置数据 压入缓存
        this.userObj.setCache(config.data);
        // this.userObj.login 储存登录信息 参数为（用户信息，token）
        this.userObj.login(res.data)
        this.GLOBAL.qiTaJiGochengNuo(config.data.nature)
        // this.$cookieStore.setCookie( 'session' ,'.eJyVjjtuAzEMRO-i2sVIIqXVXmZBiRTiwoaznyrw3UMkQPpUMxiCD-8rbHO34yOs537ZLWx3DWvIM0XuWCjKEMNoU1GGKpIXWClLWoYaMtrkEdkTUToh5t7RWiLOafg0J2pfqPo9x8aFlBE5iQ4WZgLQOk0ao2iGRIcVZObgIi_bH_K05_mndh22__qZCGarygYhptlrUapkrks1NfJ_ufR-bod9hjXegtpL9vPhtB-AL_-Avb8BCS5Uww.YaHfjg.1CFdM2Whc6p859BX0QRFj2NRcQM',100 * 365 * 24 * 60 * 60);//存入用户名，设置有效时间1分钟
        this.$router.push('./homepage')
        this.$emit('coverBox', {
          coverBox: false
        })

      } else if (res.code == 10009) {
        this.$message.error('验证码错误')
      } else {
        // this.$message.error(res.msg)
        this.$message.error(res.msg)
      }


    },
    // 去注册
    goRegister() {
      this.$router.push({
        path: './register',
        query: {
          type: this.loginType
        }
      })
    },
    // 关闭
    close() {
      this.$emit('coverBox', {
        coverBox: false
      })
    },
    // 忘记密码
    ForgetPasswordBtn() {
      this.ForgetPassword = false
      // this.$message.error('请联系管理员！')
    },
    //获取验证码
    async verifyButton() {
      if (!this.ForgetForm.mobile || this.ForgetForm.mobile == '') {
        this.$message.error('请输入手机号')
        return
      }
      this.time = 60
//60秒倒计时
      this.timer();
      await verifyInt({mobile: this.ForgetForm.mobile})
    },
    //确认忘记密码
    async ForgetFormButton() {
      if (!this.ForgetForm.mobile || this.ForgetForm.mobile == '') {
        this.$message.error('请输入手机号')
        return
      }
      if (!this.ForgetForm.verify_code || this.ForgetForm.verify_code == '') {
        this.$message.error('请输入验证码')
        return
      }
      if (!this.ForgetForm.new_password || this.ForgetForm.new_password == '') {
        this.$message.error('请输入新密码')
        return
      }
      if (!this.ForgetForm.retry_new_password || this.ForgetForm.retry_new_password == '') {
        this.$message.error('请确认新密码')
        return
      }
      this.ForgetForm.mode = 'sms'
      let res = await ForgetFormInt(this.ForgetForm)
      if (res.code == '00000') {
        this.$message.success('修改成功,请重新登录')
        // this.$router.push({
        //   path: './firstPage'
        // })
        this.ForgetPassword = true

      } else {
        this.$message.error(res.msg)
      }
    },
  }


}
</script>
<style scoped="scoped" lang="less">
.about {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999 !important;

}

.contentBox {
  width: 33vw;
  height: 55vh;
  // border: 1px green solid;
  background: #FFFFFF;
  border-radius: 8px;
  // padding: 20px;
  z-index: 999999 !important;
}

.inputboxBTn {
  width: 86%;
  height: 7.2vh;
  border-radius: 8px;
  // border: 1px solid #E5E5E5;
  margin: 0 auto;
  margin-top: 2vh;
  background: #094AAE;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 7.2vh;
  font-size: 1rem;
  text-align: center;
}

.inputbox {
  width: 86%;
  height: 7.2vh;
  border-radius: 8px;
  // border: 1px solid #E5E5E5;
  margin: 0 auto;
  margin-top: 1vh;
}


/deep/ .el-input__inner {
  height: 100%;
}

/deep/ .el-input {
  height: 100%;
  display: block;
}

.title1 {
  // text-align: center;
  font-weight: bold;
  color: #333333;
  font-size: 1.5rem;
  margin-top: 5vh;
  margin-left: 7%;
}

.passwordBox {
  // border: 1px red solid;
  width: 86%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  font-size: 0.87rem;
  margin-top: 1.8vh;
  color: #999999;
}

/deep/ .el-checkbox {
  color: #999999;
  font-weight: inherit;
}

.goRegister {
  font-size: 0.87rem;
  text-align: center;
  margin-top: 2vh;
  color: #999999;
}

.VerificationCodeBtn {
  width: 30%;
  border: 1px red solid;
  margin-left: 4%;
}


.tuxingyanzheng {
  display: flex;
  justify-content: space-between;
  width: 86%;
  height: 50px;
  margin: 0 auto;
  margin-top: 15px;
  //border: 1px red solid;
  border-radius: 4px;
  border: 1px solid #DCDFE6;

  /deep/ .el-input {
    height: 100%;
    border: none;
    //display: block;
  }

  /deep/ .el-input__inner {
    border: none;
  }

  img {
    height: 90%;
    margin-right: 3px;
    margin-top: 2.5%;
  }
}

.tuxingyanzheng > div {
  height: 50px;
  display: inline-block;
}

.fuxuank {
  margin-top: 20px;
}

.denglu {
  width: 240px;
  height: 40px;
  background: #197ab4;
  border-radius: 4px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  margin-top: 40px;
}

.verifybtn {
  //border: 1px red solid;
  height: 7.2vh;
  margin-top: 1vh;
  display: flex;
  text-align: center;
  justify-content: center;

}
</style>
